<template>
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <path d="M3.20834 7.79281L7.79168 3.20947" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.20834 3.20947L7.79168 3.20947V7.79281" stroke="#184495" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconArrowLink',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
